<template>
  <div>
    <nav>
      <div class="logo-nav">
        <img alt="Agritest Logo" src="@/assets/images/logo.png" />
      </div>
    </nav>

    <div class="interface">
      <img class="image" src="@/assets/images/fundo.jpg" alt="Fundo" />
      <div class="image-overlay"></div>
      <b-card class="login-card">
        <div class="login-card-content">
          <b-form @submit.prevent="login">
            <div class="login-header">
              <h2 class="title">Bem-vindo</h2>
              <p class="subtitle">Entre com suas credenciais</p>
            </div>

            <div class="form-group">
              <label class="label">
                <i class="fas fa-envelope label-icon"></i>
                Email
              </label>
              <b-form-input
                v-model="user.userEmail"
                type="text"
                placeholder="seuemail@exemplo.com"
                autocomplete="email"
                name="email"
                required
                class="modern-input"
              ></b-form-input>
            </div>

            <div class="form-group">
              <label class="label">
                <i class="fas fa-lock label-icon"></i>
                Senha
              </label>
              <div class="password-wrapper">
                <b-form-input
                  v-model="user.userPassword"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="Digite sua senha"
                  autocomplete="current-password"
                  name="password"
                  required
                  class="modern-input"
                ></b-form-input>
                <button
                  type="button"
                  class="password-toggle"
                  @click="showPassword = !showPassword"
                  :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
                >
                  <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>

            <div class="form-options">
              <label class="remember-me">
                <input type="checkbox" v-model="rememberMe">
                <span>Lembrar-me</span>
              </label>
              <router-link to="/forgot-password" class="forgot-password">Esqueceu a senha?</router-link>
            </div>

            <b-button class="btn-login" type="submit">
              <span>Entrar</span>
              <i class="fas fa-arrow-right"></i>
            </b-button>
          </b-form>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { request } from '@/services'
import { toast } from '@/utils'
import { DB_ROUTES, normalizeRole } from '../constants'
import { jwtDecode } from 'jwt-decode'

function roleFromLoginData (userData) {
  const tokenRole = (() => {
    try {
      const decoded = jwtDecode(userData.token)
      return decoded.role ||
        decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ||
        decoded.UserRole ||
        decoded.userRole
    } catch (error) {
      return null
    }
  })()

  return normalizeRole(userData.userRole || userData.UserRole || tokenRole)
}

export default {
  data: () => ({
    user: {
      userEmail: '',
      userPassword: ''
    },
    showPassword: false,
    rememberMe: false
  }),
  methods: {
    login () {
      request.post(
        DB_ROUTES.LOGIN,
        this.user,
        response => {
          const userData = response.data.data

          const payload = {
            user: {
              id: userData.id,
              email: userData.email,
              userRole: roleFromLoginData(userData),
              employeeId: userData.employeeId || userData.id,
              name: userData.name,
              companyId: userData.companyId
            },
            token: userData.token
          }

          this.$store.dispatch('login', payload)
          this.$router.push('/')
        },
        _ => {
          toast(this, 'danger', 'Login inválido', 'Verifique se email e senha estão corretos')
        }
      )
    }

  }
}
</script>

<style lang="stylus" scoped>
@import '../style/colors.styl'
@import '../style/fonts.styl'
@import '../style/spacing.styl'

.logo-nav
  padding-left 85px

nav
  position relative
  z-index 2
  background-color secondary
  box-shadow shadow-md
  height 100px
  display flex
  align-items center

.interface
  min-height calc(100vh - 100px)
  display flex
  align-items center
  justify-content center
  background-color secondary
  position relative
  overflow hidden

.image
  width 100%
  height 100%
  object-fit cover
  position absolute
  top 0
  left 0
  z-index 1

.image-overlay
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  background linear-gradient(135deg, rgba(255, 140, 66, 0.7) 0%, rgba(28, 78, 122, 0.8) 100%)
  z-index 2
  backdrop-filter blur(2px)

.login-card
  position relative
  z-index 3
  width 450px
  max-width 90%
  background linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)
  border-radius radius-2xl
  box-shadow 0 20px 60px rgba(0, 0, 0, 0.3)
  border none
  padding 0
  animation fadeInUp 0.6s ease-out

@keyframes fadeInUp
  from
    opacity 0
    transform translateY(30px)
  to
    opacity 1
    transform translateY(0)

.login-card-content
  padding space-2xl

.card-body
  padding 0

.login-header
  text-align center
  margin-bottom space-xl

.title
  font-size 2rem
  font-weight 700
  background linear-gradient(135deg, primary 0%, accent 100%)
  -webkit-background-clip text
  -webkit-text-fill-color transparent
  background-clip text
  margin-bottom space-sm

.subtitle
  color #6c757d
  font-size 1rem
  margin 0

.form-group
  margin-bottom space-lg

.label
  display flex
  align-items center
  font-weight 600
  color #2c3e50
  margin-bottom space-sm
  font-size 0.95rem

.label-icon
  margin-right space-xs
  color primary
  font-size 0.9rem

.modern-input
  height 50px
  border 2px solid #e0e0e0
  border-radius radius-lg
  padding 0 space-md
  font-size 1rem
  transition all transition-base
  background-color white

  &:focus
    border-color primary
    box-shadow 0 0 0 4px rgba(255, 140, 66, 0.1)
    background-color white

  &::placeholder
    color #aaa

.password-wrapper
  position relative

  .password-toggle
    position absolute
    right 15px
    top 50%
    transform translateY(-50%)
    background none
    border none
    color #6c757d
    cursor pointer
    padding space-sm
    transition all transition-fast

    &:hover
      color primary

    i
      font-size 1.1rem

.form-options
  display flex
  justify-content space-between
  align-items center
  margin-bottom space-xl
  font-size 0.9rem

.remember-me
  display flex
  align-items center
  cursor pointer
  margin 0

  input[type="checkbox"]
    margin-right space-sm
    cursor pointer
    width 18px
    height 18px

  span
    color #495057

.forgot-password
  color accent
  text-decoration none
  transition all transition-fast

  &:hover
    color primary
    text-decoration underline

.btn-login
  width 100%
  height 54px
  background linear-gradient(135deg, primary 0%, #FF7A29 100%)
  border none
  border-radius radius-lg
  font-weight 600
  font-size 1.1rem
  display flex
  align-items center
  justify-content center
  gap space-sm
  transition all transition-base
  box-shadow shadow-orange
  color white

  &:hover
    background linear-gradient(135deg, #FF7A29 0%, #FF6810 100%)
    transform translateY(-2px)
    box-shadow shadow-orange-lg
    color white

  &:active
    transform translateY(0)

  i
    transition all transition-fast

  &:hover i
    transform translateX(4px)

// Responsive
@media (max-width: 680px)
  .login-card
    width 95%

  .login-card-content
    padding space-xl space-lg

  .logo-nav
    padding-left 20px

  nav
    height 80px

  .title
    font-size 1.75rem

@media (max-width: 480px)
  .form-options
    flex-direction column
    align-items flex-start
    gap space-sm

  .forgot-password
    align-self flex-end

</style>
